import logo from './logo.svg';
import './App.css';
import React from 'react';
import HomePage from './Views/HomePage';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
